import script from "./promotionCardNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./promotionCardNew.vue?vue&type=script&setup=true&lang=ts"

import "./promotionCardNew.vue?vue&type=style&index=0&id=2672c9c7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2672c9c7"]])

export default __exports__